var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-user-promotion-email"},[_vm._v(_vm._s(_vm.email))])
}
var staticRenderFns = []

export { render, staticRenderFns }